import React, { useState, useEffect } from 'react';
import axios from 'axios';

import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import EventOutlinedIcon from '@material-ui/icons/EventOutlined';
import Fab from '@material-ui/core/Fab';
import Button from '@material-ui/core/Button';
import AddIcon from '@material-ui/icons/Add';
import LocalAtmIcon from '@material-ui/icons/LocalAtm';
import RemoveCircleOutlinedIcon from '@material-ui/icons/RemoveCircleOutlined';
import FastfoodOutlinedIcon from '@material-ui/icons/FastfoodOutlined';
import PeopleOutlineOutlinedIcon from '@material-ui/icons/PeopleOutlineOutlined';
import ClassOutlinedIcon from '@material-ui/icons/ClassOutlined';
import Typography from '@material-ui/core/Typography';
import Tooltip from '@material-ui/core/Tooltip';
import ConfirmationNumberOutlinedIcon from '@material-ui/icons/ConfirmationNumberOutlined';

import { checkTokenExpirationMiddleware } from '../../../../middlewares/users-auth.middleware';
import CustomSelect from '../custom-select';

const HotelAccommodationForm = ({ attachmentUpload, onAttachmentChange }) => {
    const [mealPlan, setMealPlan] = useState(null);
    const [roomType, setRoomType] = useState(null);
    const [roomCategory, setRoomCategory] = useState(null);
    const [, setError] = useState(null);
    const [user] = useState(checkTokenExpirationMiddleware());
    const [addRow, setAddRow] = useState([]);

    const appendRow = () => {
        let rows = [...addRow];
        rows.push(1);
        setAddRow(rows);
    };

    const removeRow = () => {
        let rows = [...addRow];
        rows.pop();
        setAddRow(rows);
    };

    let headers = {
        "Authorization": `Bearer ${user.Token}`
    };
    useEffect(() => {
        axios.get("/api/mealplan", { headers: headers })
            .then(res => { setMealPlan(res.data); })
            .catch(err => { setError({ error: "Error Loading page" }); });
        axios.get("/api/roomcategory", { headers: headers })
            .then(res => { setRoomCategory(res.data); })
            .catch(err => { setError({ error: "Error Loading page" }); });
        axios.get("/api/roomtype", { headers: headers })
            .then(res => { setRoomType(res.data); })
            .catch(err => { setError({ error: "Error Loading page" }); });
    }, []);

    return (
        <>
            <Grid
                id="ho-aco"
                container
                spacing={1}
                style={{ margin: `15px`, padding: `15px` }}
            >
                <Grid container item xs={12} spacing={2}>
                    <Typography variant="subtitle2" gutterBottom>
                        Acommodation Details
                    </Typography>
                </Grid>

                <Grid container item xs={12} spacing={2}>
                    <RoomRow
                        extra={false}
                        mealPlan={mealPlan}
                        roomCategory={roomCategory}
                        roomType={roomType}
                        removeRow={removeRow}
                    />
                    {
                        addRow.map((item, index) =>
                            <RoomRow
                                key={index}
                                extra={true}
                                mealPlan={mealPlan}
                                roomCategory={roomCategory}
                                roomType={roomType}
                                removeRow={removeRow}
                            />
                        )
                    }
                </Grid>

                <Grid container justify="flex-end">
                    <Tooltip title="Add Room" placement="left">
                        <Fab size="small" color="primary" aria-label="add" onClick={appendRow}>
                            <AddIcon />
                        </Fab>
                    </Tooltip>
                </Grid>

                <Grid container item xs={12} spacing={2}>
                    <Grid item sm={12} md={4} lg={2}>
                        <TextField
                            label="Payment Policy"
                            multiline
                            fullWidth
                            required
                            rows={3}
                            variant="outlined"
                        />
                    </Grid>
                    <Grid item sm={12} md={6} lg={2}>
                        <TextField
                            label="Free Policy"
                            multiline
                            fullWidth
                            required
                            rows={3}
                            variant="outlined"
                        />
                    </Grid>
                    <Grid item sm={12} md={4} lg={2}>
                        <TextField
                            label="Cancellation Policy"
                            multiline
                            fullWidth
                            required
                            rows={3}
                            variant="outlined"
                        />
                    </Grid>
                    <Grid item sm={12} md={4} lg={2}>
                        <TextField
                            label="Children Policy"
                            multiline
                            fullWidth
                            required
                            rows={3}
                            variant="outlined"
                        />
                    </Grid>
                    <Grid item sm={12} md={4} lg={2}>
                        <TextField
                            label="Notes"
                            multiline
                            fullWidth
                            rows={3}
                            variant="outlined"
                        />
                    </Grid>
                    <Grid item sm={6} md={4} lg={2}>
                        <input
                            accept=".jpg,.jpeg,.png,.bmp,.gif,.pdf,.doc,.docx,.xls,.pptx,.xlsx"
                            style={{ display: `none` }}
                            id={`file-attach`}
                            type="file"
                            onChange={onAttachmentChange}
                        />
                        <label htmlFor={`file-attach`}>
                            <Button variant="outlined" color="primary" component="span">
                                Attachment
                        </Button>
                        </label>
                        {
                            attachmentUpload && attachmentUpload.uploading ?
                                <div style={{ marginTop: "8px" }}>Uploading attachment...</div>
                                : null
                        }
                        {
                            attachmentUpload && attachmentUpload.originalFileName ?
                                <div style={{ marginTop: "8px" }}>{attachmentUpload.originalFileName}</div>
                                : null
                        }
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}

const RoomRow = ({ mealPlan, roomType, roomCategory, removeRow, extra }) => {
    return (
        <>
            <Grid
                container item xs={12} spacing={2}
                style={{
                    border: `solid 1px black`,
                    padding: `4px`,
                    marginTop: `15px`
                }}
                className="ro-rw"
            >
                <Grid item sm={4} md={4} lg={3}>
                    <TextField
                        label="Check In"
                        type="datetime-local"
                        fullWidth
                        required
                        InputLabelProps={{
                            shrink: true,
                        }}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <EventOutlinedIcon fontSize={"small"} />
                                </InputAdornment>
                            )
                        }}
                    />
                </Grid>
                <Grid item sm={4} md={4} lg={3}>
                    <TextField
                        label="Check Out"
                        type="datetime-local"
                        fullWidth
                        required
                        InputLabelProps={{
                            shrink: true,
                        }}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <EventOutlinedIcon fontSize={"small"} />
                                </InputAdornment>
                            )
                        }}
                    />
                </Grid>
                <Grid item sm={4} md={4} lg={3}>
                    <CustomSelect
                        data={roomCategory}
                        label={"Room Category"}
                        required={true}
                        icon={<ClassOutlinedIcon fontSize={"small"} />}
                    />
                </Grid>
                <Grid item sm={4} md={4} lg={3}>
                    <CustomSelect
                        data={roomType}
                        label={"Room Type"}
                        required={true}
                        icon={<PeopleOutlineOutlinedIcon fontSize={"small"} />}
                    />
                </Grid>
                <Grid item sm={4} md={4} lg={3}>
                    <CustomSelect
                        data={mealPlan}
                        label={"Meal Plan"}
                        required={true}
                        icon={<FastfoodOutlinedIcon fontSize={"small"} />}
                    />
                </Grid>
                <Grid item sm={4} md={4} lg={3}>
                    <TextField
                        label={"No. of Rooms"}
                        fullWidth
                        type={"number"}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <ConfirmationNumberOutlinedIcon fontSize={"small"} />
                                </InputAdornment>
                            ),
                            inputProps: { min: 1 }
                        }}
                        required
                    />
                </Grid>
                <Grid item sm={4} md={4} lg={3}>
                    <TextField
                        label={"Room Price"}
                        fullWidth
                        type={"number"}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <LocalAtmIcon fontSize={"small"} />
                                </InputAdornment>
                            ),
                            inputProps: { min: 1 }
                        }}
                        required
                    />
                </Grid>
                {
                    extra === true ?
                        <Grid item sm={1} md={1} lg={1}>
                            <RemoveCircleOutlinedIcon color="error" fontSize="small" onClick={() => removeRow()} />
                        </Grid>
                        :
                        null
                }
            </Grid>
        </>
    )
};

export default HotelAccommodationForm;
